import { useBatchDeleteActions, useDeleteAction } from "@api";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ConfirmationModal, IconButtonVariant, LoadingModal } from "@styleguide";
import { useEffect, useState } from "react";

const DeleteActionButton = (props) => {
  const { action, mergedActions, onClose, hideBackdrop, onButtonClick } = props;
  const [{ data: deletedAction, loading: loadingDeleteAction }, deleteAction] = useDeleteAction();
  const [{ response: batchDeletedActionResponse, loading: loadingBatchDeleteAction }, batchDeleteAction] =
    useBatchDeleteActions();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (
      (deletedAction && deletedAction.active === false) ||
      (batchDeletedActionResponse && batchDeletedActionResponse.status === 204)
    ) {
      if (deletedAction) {
        window.publish("feedback", {
          severity: "success",
          message: "L'action a bien été supprimée",
        });
      } else {
        window.publish("feedback", {
          severity: "success",
          message: "Les actions ont bien été supprimées",
        });
      }

      setIsDeleteModalOpen(false);
      if (onClose) {
        onClose([action._id, ...(batchDeletedActionResponse ? mergedActions.map((action) => action._id) : [])]);
      }

      if (typeof onButtonClick === "function") {
        onButtonClick();
      }
    }
  }, [deletedAction, batchDeletedActionResponse]);

  return (
    <>
      <IconButtonVariant
        variant="elevated"
        onClick={() => {
          setIsDeleteModalOpen(true);
          if (typeof onButtonClick === "function") {
            onButtonClick();
          }
        }}
      >
        <DeleteOutlineIcon fontSize="small" color="primary" />
      </IconButtonVariant>
      <ConfirmationModal
        id="confirm-delete-action"
        title={`Suppression ${mergedActions ? "des actions" : "de l'action"}`}
        textConfirmButton="Valider"
        textCancelButton="Annuler"
        open={isDeleteModalOpen}
        onConfirmClick={() =>
          mergedActions?.length
            ? batchDeleteAction({ actionIds: [action._id, ...mergedActions.map((action) => action._id)] })
            : deleteAction(action._id)
        }
        onCancelClick={() => {
          setIsDeleteModalOpen(false);
          if (typeof onButtonClick === "function") {
            onButtonClick();
          }
        }}
        hideBackdrop={hideBackdrop}
        PaperProps={{
          sx: { visibility: loadingDeleteAction || loadingBatchDeleteAction ? "hidden" : "visible" },
        }}
      >
        Êtes-vous sûr de vouloir supprimer {mergedActions ? "ces actions" : "cette action"} ?
      </ConfirmationModal>
      <LoadingModal
        open={loadingDeleteAction || loadingBatchDeleteAction}
        message={`Suppression ${mergedActions ? "des actions" : "de l'action"}  en cours...`}
        hideBackdrop
      />
    </>
  );
};

// biome-ignore lint/style/noDefaultExport: <explanation>
export default DeleteActionButton;
